export const PERMISSIONS = {
    APPEX: 'appex',
    APPEX_NOTIFICATION: 'appex.notification',
    APPEX_EXPERIENCE: 'appex.experience',
    APPEX_EXPERIENCE_CREATE: 'appex.experience.create',
    APPEX_EXPERIENCE_EDIT: 'appex.experience.edit',
    APPEX_EXPERIENCE_DELETE: 'appex.experience.delete',
    APPEX_EXTERNAL_USER: 'appex.external_user',
    APPEX_EXTERNAL_USER_CREATE: 'appex.external_user.create',
    APPEX_EXTERNAL_USER_EDIT: 'appex.external_user.edit',
    APPEX_EXTERNAL_USER_DELETE: 'appex.external_user.delete',
    APPEX_REPORT: 'appex.report',
    APPEX_KNOWLEDGE_SETTINGS: 'appex.knowledge_settings',
    APPEX_INTEGRATIONS: 'appex.integrations',
    APPEX_INTEGRATIONS_CREATE: 'appex.integrations.create',
    APPEX_INTEGRATIONS_DELETE: 'appex.integrations.delete',
    APPEX_ADMIN: 'appex.admin',
    APPEX_ADMIN_USER: 'appex.admin.user',
    APPEX_ADMIN_USER_DELETE: 'appex.admin.user.delete',
    APPEX_ADMIN_USER_SET_ROLE: 'appex.admin.user.set_role',
    APPEX_ADMIN_USER_DISABLE: 'appex.admin.user.disable',
    APPEX_USER_EDIT_OWN: 'appex.user.edit_own',
    APPEX_COMPANY: 'appex.company',
    APPEX_COMPANY_EDIT: 'appex.company.edit',
    APPEX_DYNAMIC_FIELD: 'appex.dynamic_field',
    APPEX_DYNAMIC_FIELD_CREATE: 'appex.dynamic_field.create',
    APPEX_DYNAMIC_FIELD_EDIT: 'appex.dynamic_field.edit',
    APPEX_DYNAMIC_FIELD_DELETE: 'appex.dynamic_field.delete',
    APPEX_LESSON: 'appex.lesson',
    APPEX_LESSON_CREATE: 'appex.lesson.create',
    APPEX_LESSON_EDIT: 'appex.lesson.edit',
    APPEX_LESSON_EDIT_ALL: 'appex.lesson.edit.all',
    APPEX_LESSON_EDIT_ORDER: 'appex.lesson.edit_order',
    APPEX_LESSON_APPROVE: 'appex.lesson.approve',
    APPEX_LESSON_MANDATORY: 'appex.lesson.mandatory',
    APPEX_LESSON_DELETE: 'appex.lesson.delete',
    APPEX_APPLIED_LESSON: 'appex.applied_lesson',
    APPEX_APPLIED_LESSON_CREATE: 'appex.applied_lesson.create',
    APPEX_APPLIED_LESSON_EDIT: 'appex.applied_lesson.edit',
    APPEX_APPLIED_LESSON_EDIT_ALL: 'appex.applied_lesson.edit.all',
    APPEX_APPLIED_LESSON_DELETE: 'appex.applied_lesson.delete',
    APPEX_PM_LESSON: 'appex.pm_lesson',
    APPEX_PM_LESSON_CREATE: 'appex.pm_lesson.create',
    APPEX_PM_LESSON_EDIT: 'appex.pm_lesson.edit',
    APPEX_PM_LESSON_EDIT_ALL: 'appex.pm_lesson.edit.all',
    APPEX_PM_LESSON_EDIT_ORDER: 'appex.pm_lesson.edit_order',
    APPEX_PM_LESSON_APPROVE: 'appex.pm_lesson.approve',
    APPEX_PM_LESSON_MANDATORY: 'appex.pm_lesson.mandatory',
    APPEX_PM_LESSON_DELETE: 'appex.pm_lesson.delete',
    APPEX_PM_APPLIED_LESSON: 'appex.pm_applied_lesson',
    APPEX_PM_APPLIED_LESSON_CREATE: 'appex.pm_applied_lesson.create',
    APPEX_PM_APPLIED_LESSON_EDIT: 'appex.pm_applied_lesson.edit',
    APPEX_PM_APPLIED_LESSON_EDIT_ALL: 'appex.pm_applied_lesson.edit.all',
    APPEX_PM_APPLIED_LESSON_DELETE: 'appex.pm_applied_lesson.delete',
    APPEX_X_LESSON: 'appex.x_lesson',
    APPEX_X_LESSON_CREATE: 'appex.x_lesson.create',
    APPEX_X_LESSON_EDIT: 'appex.x_lesson.edit',
    APPEX_X_LESSON_EDIT_ALL: 'appex.x_lesson.edit.all',
    APPEX_X_LESSON_EDIT_ORDER: 'appex.x_lesson.edit_order',
    APPEX_X_LESSON_APPROVE: 'appex.x_lesson.approve',
    APPEX_X_LESSON_MANDATORY: 'appex.x_lesson.mandatory',
    APPEX_X_LESSON_DELETE: 'appex.x_lesson.delete',
    APPEX_X_APPLIED_LESSON: 'appex.x_applied_lesson',
    APPEX_X_APPLIED_LESSON_CREATE: 'appex.x_applied_lesson.create',
    APPEX_X_APPLIED_LESSON_EDIT: 'appex.x_applied_lesson.edit',
    APPEX_X_APPLIED_LESSON_EDIT_ALL: 'appex.x_applied_lesson.edit.all',
    APPEX_X_APPLIED_LESSON_DELETE: 'appex.x_applied_lesson.delete',
    APPEX_PHASE: 'appex.phase',
    APPEX_PHASE_CREATE: 'appex.phase.create',
    APPEX_PHASE_EDIT: 'appex.phase.edit',
    APPEX_PHASE_DELETE: 'appex.phase.delete',
    APPEX_PM_PHASE: 'appex.pm_phase',
    APPEX_PM_PHASE_CREATE: 'appex.pm_phase.create',
    APPEX_PM_PHASE_EDIT: 'appex.pm_phase.edit',
    APPEX_PM_PHASE_DELETE: 'appex.pm_phase.delete',
    APPEX_PM_SUB_PHASE: 'appex.pm_sub_phase',
    APPEX_PM_SUB_PHASE_GLOBAL: 'appex.pm_sub_phase.global',
    APPEX_PM_SUB_PHASE_CREATE: 'appex.pm_sub_phase.create',
    APPEX_PM_SUB_PHASE_EDIT: 'appex.pm_sub_phase.edit',
    APPEX_PM_SUB_PHASE_DELETE: 'appex.pm_sub_phase.delete',
    APPEX_PROJECT: 'appex.project',
    APPEX_PROJECT_PRINT: 'appex.project.print',
    APPEX_PROJECT_INTEGRATE: 'appex.project.integrate',
    APPEX_PROJECT_ALL: 'appex.project.all',
    APPEX_PROJECT_CREATE: 'appex.project.create',
    APPEX_PROJECT_EDIT: 'appex.project.edit',
    APPEX_PROJECT_EDIT_ALL: 'appex.project.edit.all',
    APPEX_PROJECT_DELETE_ALL: 'appex.project.delete_all',
    APPEX_PROJECT_DELETE_OWN: 'appex.project.delete_own',
    APPEX_TAG: 'appex.tag',
    APPEX_TAG_CREATE: 'appex.tag.create',
    APPEX_TAG_EDIT: 'appex.tag.edit',
    APPEX_TAG_DELETE: 'appex.tag.delete',
    APPEX_TOPIC: 'appex.topic',
    APPEX_TOPIC_GLOBAL: 'appex.topic.global',
    APPEX_TOPIC_CREATE: 'appex.topic.create',
    APPEX_TOPIC_EDIT: 'appex.topic.edit',
    APPEX_TOPIC_DELETE: 'appex.topic.delete',
    APPEX_TRADE: 'appex.trade',
    APPEX_TRADE_CREATE: 'appex.trade.create',
    APPEX_TRADE_EDIT: 'appex.trade.edit',
    APPEX_TRADE_DELETE: 'appex.trade.delete',
    APPEX_X_PROCESS: 'appex.x_process',
    APPEX_X_PROCESS_CREATE: 'appex.x_process.create',
    APPEX_X_PROCESS_EDIT: 'appex.x_process.edit',
    APPEX_X_PROCESS_DELETE: 'appex.x_process.delete',
    APPEX_X_SUB_PROCESS: 'appex.x_sub_process',
    APPEX_X_SUB_PROCESS_CREATE: 'appex.x_sub_process.create',
    APPEX_X_SUB_PROCESS_EDIT: 'appex.x_sub_process.edit',
    APPEX_X_SUB_PROCESS_DELETE: 'appex.x_sub_process.delete',
    APPEX_WORKSHEET: 'appex.worksheet',
    APPEX_WORKSHEET_PRINT: 'appex.worksheet.print',
    APPEX_WORKSHEET_TODO: 'appex.worksheet.todo',
    APPEX_WORKSHEET_TODO_EMAIL: 'appex.worksheet.todo.email',
    APPEX_WORKSHEET_CREATE: 'appex.worksheet.create',
    APPEX_WORKSHEET_EDIT: 'appex.worksheet.edit',
    APPEX_WORKSHEET_DELETE: 'appex.worksheet.delete',
    APPEX_PM_WORKSHEET: 'appex.pm_worksheet',
    APPEX_PM_WORKSHEET_PRINT: 'appex.pm_worksheet.print',
    APPEX_PM_WORKSHEET_TODO: 'appex.pm_worksheet.todo',
    APPEX_PM_WORKSHEET_TODO_EMAIL: 'appex.pm_worksheet.todo.email',
    APPEX_PM_WORKSHEET_CREATE: 'appex.pm_worksheet.create',
    APPEX_PM_WORKSHEET_EDIT: 'appex.pm_worksheet.edit',
    APPEX_PM_WORKSHEET_DELETE: 'appex.pm_worksheet.delete',
    APPEX_X_WORKSHEET: 'appex.x_worksheet',
    APPEX_X_WORKSHEET_PRINT: 'appex.x_worksheet.print',
    APPEX_X_WORKSHEET_TODO: 'appex.x_worksheet.todo',
    APPEX_X_WORKSHEET_TODO_EMAIL: 'appex.x_worksheet.todo.email',
    APPEX_X_WORKSHEET_CREATE: 'appex.x_worksheet.create',
    APPEX_X_WORKSHEET_EDIT: 'appex.x_worksheet.edit',
    APPEX_X_WORKSHEET_DELETE: 'appex.x_worksheet.delete',
    APPEX_API_TOKEN: 'appex.api_token',
    APPEX_API_TOKEN_CREATE: 'appex.api_token.create',
    APPEX_API_TOKEN_DELETE: 'appex.api_token.delete',
    APPEX_ORDER: 'appex.order',
    APPEX_ORDER_WORKSHEET: 'appex.order_worksheet',
    APPEX_ORDER_WORKSHEET_EDIT: 'appex.order_worksheet.edit',
    APPEX_ORDER_WORKSHEET_EDIT_EXECUTIVE: 'appex.order_worksheet.edit_executive',
    APPEX_ORDER_WORKSHEET_EDIT_EXECUTIVE_SCHEDULE: 'appex.order_worksheet.edit_executive_schedule',
    APPEX_ORDER_WORKSHEET_EDIT_CONTROLLING: 'appex.order_worksheet.edit_controlling',
    APPEX_ORDER_WORKSHEET_EDIT_CONTROLLING_SCHEDULE: 'appex.order_worksheet.edit_controlling_schedule',
    APPEX_ORDER_WORKSHEET_CREATE: 'appex.order_worksheet.create',
    APPEX_ORDER_WORKSHEET_DELETE: 'appex.order_worksheet.delete',
    APPEX_ORDER_WORKSHEET_DELIVERY_OBJECT: 'appex.order_worksheet.delivery_object',
    APPEX_ORDER_WORKSHEET_DELIVERY_OBJECT_LINKS: 'appex.order_worksheet.delivery_object.links',
    APPEX_ORDER_WORKSHEET_DELIVERY_OBJECT_LINKS_CREATE: 'appex.order_worksheet.delivery_object.links.create',
    APPEX_ORDER_WORKSHEET_DELIVERY_OBJECT_LINKS_DELETE: 'appex.order_worksheet.delivery_object.links.delete',
    APPEX_ORDER_WORKSHEET_BIM_USECASE: 'appex.order_worksheet.bim_usecase',
    APPEX_ORDER_WORKSHEET_BIM_USECASE_LINKS: 'appex.order_worksheet.bim_usecase.links',
    APPEX_ORDER_WORKSHEET_BIM_USECASE_LINKS_CREATE: 'appex.order_worksheet.bim_usecase.links.create',
    APPEX_ORDER_WORKSHEET_BIM_USECASE_LINKS_DELETE: 'appex.order_worksheet.bim_usecase.links.delete',
    APPEX_ORDER_WORKSHEET_BIM_TARGET: 'appex.order_worksheet.bim_target',
    APPEX_ORDER_WORKSHEET_BIM_TARGET_LINKS: 'appex.order_worksheet.bim_target.links',
    APPEX_ORDER_WORKSHEET_BIM_TARGET_LINKS_CREATE: 'appex.order_worksheet.bim_target.links.create',
    APPEX_ORDER_WORKSHEET_BIM_TARGET_LINKS_DELETE: 'appex.order_worksheet.bim_target.links.delete',
    APPEX_ORDER_DELIVERY_OBJECT: 'appex.order_delivery_object',
    APPEX_ORDER_DELIVERY_OBJECT_CREATE: 'appex.order_delivery_object.create',
    APPEX_ORDER_DELIVERY_OBJECT_EDIT: 'appex.order_delivery_object.edit',
    APPEX_ORDER_DELIVERY_OBJECT_DELETE: 'appex.order_delivery_object.delete',
    APPEX_ORDER_BIM_USECASE: 'appex.order_bim_usecase',
    APPEX_ORDER_BIM_USECASE_CREATE: 'appex.order_bim_usecase.create',
    APPEX_ORDER_BIM_USECASE_EDIT: 'appex.order_bim_usecase.edit',
    APPEX_ORDER_BIM_USECASE_DELETE: 'appex.order_bim_usecase.delete',
    APPEX_ORDER_BIM_TARGET: 'appex.order_bim_target',
    APPEX_ORDER_BIM_TARGET_CREATE: 'appex.order_bim_target.create',
    APPEX_ORDER_BIM_TARGET_EDIT: 'appex.order_bim_target.edit',
    APPEX_ORDER_BIM_TARGET_DELETE: 'appex.order_bim_target.delete',
    APPEX_ORDER_BIM_EXECUTION_PLAN: 'appex.order_bim_execution_plan',
    APPEX_ORDER_BIM_EXECUTION_PLAN_CREATE: 'appex.order_bim_execution_plan.create',
    APPEX_ORDER_BIM_EXECUTION_PLAN_EDIT: 'appex.order_bim_execution_plan.edit',
    APPEX_ORDER_BIM_EXECUTION_PLAN_DELETE: 'appex.order_bim_execution_plan.delete',
} as const;

export type EnumPermission = typeof PERMISSIONS[keyof typeof PERMISSIONS];
